/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_LedeInputs */

const en_start_page_lede = /** @type {(inputs: Start_Page_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An account, your hours and a link for your clients. About fifteen minutes, no onboarding and no training, and the first person can book a session the same day.`)
};

const pl_start_page_lede = /** @type {(inputs: Start_Page_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto, godziny i link dla podopiecznych. Około piętnastu minut, bez wdrożenia i bez szkoleń, a pierwsza osoba może zarezerwować trening tego samego dnia.`)
};

/**
* | output |
* | --- |
* | "An account, your hours and a link for your clients. About fifteen minutes, no onboarding and no training, and the first person can book a session the same day." |
*
* @param {Start_Page_LedeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_lede = /** @type {((inputs?: Start_Page_LedeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_LedeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_lede(inputs)
	return en_start_page_lede(inputs)
});